import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Scroll-triggered reveal wrapper.
export const Reveal = ({
  children,
  className,
  delay = 0,
  y = 40,
  as = "div",
  once = true,
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
};

// Stagger container + item helpers
export const StaggerGroup = ({ children, className, delayChildren = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{
      hidden: {},
      show: {
        transition: { staggerChildren: 0.1, delayChildren },
      },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className, y = 30 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

export { EASE };
